import { render } from "./QuetMaQR.vue?vue&type=template&id=8c7d8560&scoped=true"
import script from "./QuetMaQR.vue?vue&type=script&lang=js"
export * from "./QuetMaQR.vue?vue&type=script&lang=js"

import "./QuetMaQR.vue?vue&type=style&index=0&id=8c7d8560&scoped=true&lang=css"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7d8560"]])

export default __exports__